const CoachHome = () => {
  return (
    <div className="w-full h-full flex items-center justify-center text-3xl font-bold">
      Coach Dashboard Placeholder
    </div>
  );
};

export default CoachHome;
